import { type FC } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

import { Link } from 'dibs-elements/exports/Link.tsx';
import ChevronUp from 'dibs-icons/exports/ChevronUp.ts';
import ChevronDown from 'dibs-icons/exports/ChevronDown.ts';

import styles from './ThumbScrollArrow.scss';

export const ThumbScrollArrow: FC<{
    direction: 'up' | 'down';
    onClick: () => void;
}> = ({ direction, onClick }) => {
    const Icon = direction === 'up' ? ChevronUp : ChevronDown;
    return (
        <Link
            className={classnames(
                dibsCss.zBump,
                dibsCss.absolute,
                dibsCss.left50,
                dibsCss.flex,
                dibsCss.itemsCenter,
                dibsCss.justifyCenter,
                dibsCss.p0,
                dibsCss.textNoir,
                dibsCss.roundedFull,
                styles.thumbArrow,
                direction === 'up' ? styles.thumbArrowUp : styles.thumbArrowDown
            )}
            onClick={onClick}
            dataTn={`thumb-scroll-${direction}`}
            ariaLabel={`Scroll thumbnails ${direction}`}
        >
            <Icon variation="20" />
        </Link>
    );
};
